// extracted by mini-css-extract-plugin
module.exports = {"container":"_1B92lRx2kwg6Aq2Vq1czYq"};